module.exports = __webpack_public_path__ + "static/media/magazine.657ae784.png";